import type { OAuthContext } from '@common/api/authService';
import {
    getLocalStorageJson,
    removeLocalStorageItem,
    setLocalStorageJson
} from '@common/utils/storage';
import { useCallback, useEffect } from 'react';

const OAUTH_CONTEXT_KEY = 'bustly_oauth_context';

export const useOauth = () => {
    const storeOAuthContextFromUrl = useCallback((search?: string): OAuthContext | null => {
        if (typeof window === 'undefined') return null;

        const searchParams = new URLSearchParams(search ?? window.location.search);
        const clientId = searchParams.get('client_id');
        const redirectUri = searchParams.get('redirect_uri');
        const deviceId = searchParams.get('device_id');
        const loginTraceId = searchParams.get('login_trace_id');

        if (clientId && loginTraceId) {
            const oauthContext: OAuthContext = {
                client_id: clientId,
                redirect_uri: redirectUri,
                device_id: deviceId,
                login_trace_id: loginTraceId
            };
            setLocalStorageJson(OAUTH_CONTEXT_KEY, oauthContext);
            return oauthContext;
        }

        return null;
    }, []);

    const getOAuthContext = useCallback((): OAuthContext | null => {
        return getLocalStorageJson<OAuthContext>(OAUTH_CONTEXT_KEY);
    }, []);

    const clearOAuthContext = useCallback((): void => {
        removeLocalStorageItem(OAUTH_CONTEXT_KEY);
    }, []);

    // 直接从当前 URL 获取 OAuth 参数
    useEffect(() => {
        storeOAuthContextFromUrl();
    }, [storeOAuthContextFromUrl]);

    return {
        getOAuthContext,
        clearOAuthContext,
        OAUTH_CONTEXT_KEY
    };
};
